import { apolloClient } from '@signing-page/apollo';
import { entityQuery, themeQuery } from '@signing-page/api/entity/graphql/entity.queries';
import { IEntity } from '@signing-page/entity/types/entity';
import { ITheme } from '@signing-page/entity/types/theme';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class EntityService {
  static async getEntity(): Promise<IEntity> {
    const {
      data: { entity },
    } = await apolloClient.query({
      query: entityQuery,
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return entity;
  }

  static async getTheme(documentId): Promise<ITheme> {
    const {
      data: { theme },
    } = await apolloClient.query({
      query: themeQuery,
      fetchPolicy: EFetchPolicy.NetworkOnly,
      variables: {
        documentId,
      },
    });
    return theme;
  }
}
